import React, { useCallback, useEffect, useState } from 'react';
import classNames from 'classnames';

import { getShortName } from '~/user/helpers';
import { useStoreState } from '~/store';

import classes from './style.module.scss';
import { User } from '~/types';

export interface UserAvatarProps {
  className?: string
  active?: boolean
  hovering?: boolean
  userName?: User['name']
  avatar?: User['avatar']
  onClick?: () => void
}

export type UserAvatarComponent = React.FC<UserAvatarProps>

export const UserAvatar: UserAvatarComponent = ({ className, active, hovering, onClick, userName, avatar: initialAvatar }) => {
  const uname = useStoreState(state => state.user.data.name);
  const uavatar = useStoreState(state => state.user.data.avatar);
  const uimage = useStoreState(state => state.user.data.image);
  const name = userName ? userName : uname;
  const [avatar, setAvatar] = useState<string>();

  const cN = classNames(classes['user-avatar'], className, {
    [classes['active']]: active,
    [classes['hovering']]: hovering,
    [classes['user-name-intials']]: !avatar
  });

  const getInitialAvatar = useCallback(() => {
    let resolvedAvatar = initialAvatar ?? uavatar;
    resolvedAvatar = resolvedAvatar?.includes('user_default.png') ? "" : resolvedAvatar;
    setAvatar(resolvedAvatar);
  }, [initialAvatar, uavatar])

  const handleError = useCallback(() => {
    setAvatar((prev) =>
      prev === uimage ? '' : uimage
    );
  }, [uimage]);

  useEffect(() => {
    getInitialAvatar();
  }, [getInitialAvatar])

  return (
    <div className={cN} onClick={onClick}>
      {avatar ? <img src={avatar} alt={''} onError={handleError} /> : getShortName(name)}
    </div>
  );
};

export default UserAvatar
